<script>

import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';

import "@simonwep/pickr/dist/themes/classic.min.css"; // 'classic' theme 
import "@simonwep/pickr/dist/themes/monolith.min.css"; // 'monolith' theme 
import "@simonwep/pickr/dist/themes/nano.min.css";
import DataTable from 'datatables.net-vue3';

export default {
  page: {
    title: "List Of Pending Delivery Method",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
        role:localStorage.getItem('role'),
      title: "List Of Pending Customer Approval",
      items: [
        {
          text: "Order",
          href: "/",
        },
        {
          text: "List Of Pending Customer Approval",
          active: true,
        },
      ],
        PickUpdate:'',
        OrderID_:'',
        ridername:'',
        typedeliver:'',


        remark:'',

        OrderList:[],
        RiderList:[],
        DetailRider:[],

      //loding
        OrderSeen:true,
        RiderSeen:true,

        AssignRiderSeen:true,
        //button hide
        showFormToAssignRider:false,
        ButtonSeen:true,

      //
    };
  },


     methods: {
        getOrder(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'status/5')
            .then(response => {
                if (response) {
                    if(response.data.status=='error'){
                        this.messageBag = response.data.msj;
                        this.OrderSeen = false;
                    }else{
                        this.OrderList = response.data;
                        this.OrderSeen = false;
                    }
                    
                } else {
                    this.messageBag = ['No record.'];
                    this.OrderSeen = false;
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
                    this.OrderSeen = false;
            });
        },

        // a href
        GoToDetailPage(OrderID){
            // console.log(OrderID);
            this.$router.push('/order/details/'+OrderID); 
        }

        //end of a href
     },
     
     mounted() {
        if(this.role != 3){
            this.getOrder();
        }else{
            alert('You are not authorized to view the requested page!')
        }
	},


  components: {
    Layout,
    PageHeader,
    DataTable,
  },
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header align-items-center d-flex">
                    <h4 class="card-title mb-0 flex-grow-1">List Of Order</h4>
                    </div>

                    <div class="card-body">
                        <div class="live-preview">
                            <div class="row align-items-center g-12">
                                <div class="col-lg-12">
                                    <div class="table-responsive table-card">
                                        <div v-if='OrderSeen'>
                                            <div class="spinner-border text-success" role="status">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                        <div v-else>
                                            
                                            <DataTable class="table align-middle table-nowrap mb-0">
                                                <thead >
                                                    <tr>
                                                        <th scope="col">NO.</th>
                                                        <th scope="col">ORDER NO</th>
                                                        <th scope="col">ORDER DATE</th>
                                                        <th scope="col">COMPANY NAME</th>
                                                        <th scope="col">PERSON IN CHARGE</th>
                                                        <th scope="col">QTY</th>
                                                        <th scope="col">TOTAL AMOUNT</th>
                                                        <th scope="col">STATUS</th>
                                                        <th scope="col">ACTION</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in OrderList" :key="index" class="content">
                                                        <td>{{ index+1 }}</td>
                                                        <td>{{ item.orderId }}</td>
                                                        <td>{{ item.order_date }}</td>
                                                        <td>{{ item.company_name }}</td>
                                                        <td>{{ item.CusName }}</td>
                                                        <td>{{ item.quantity }}</td>
                                                        <td>{{ item.currency}} {{ item.totalQuotation }}</td>
                                                        <td>
                                                            <span class="badge" :class="'badge-soft-'+item.StatusBadge">
                                                                {{ item.status }}
                                                            </span>    
                                                        </td>
                                                        <td> 
                                                            <i @click="GoToDetailPage(item.id)" class="ri-eye-line" style="cursor: pointer;"></i> 
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </DataTable>
                                            <br><br><br>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>